import { useMutation, useQueryClient } from '@tanstack/react-query';
import { restoreConfig, ConfigurationObject } from '../services/configs-api';

/**
 * TanStack Mutation hook for restoring a pending-deletion configuration.
 * Invalidates the configs list cache on success.
 */
export function useRestoreConfig() {
  const queryClient = useQueryClient();

  return useMutation<ConfigurationObject, Error, string>({
    mutationFn: (configId) => restoreConfig(configId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['configs'] });
    },
  });
}
